import { createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin(nuxtApp => {
  const { public: { NUXT_GTM_ID, NUXT_ENV } } = useRuntimeConfig()
  const isProduction = NUXT_ENV === 'production'

  nuxtApp.vueApp.use(createGtm({
    id: NUXT_GTM_ID || 'GTM-DEV',
    enabled: isProduction && !!NUXT_GTM_ID,
    debug: !isProduction,
    loadScript: true,
    vueRouter: useRouter()
  }))
})
